import { render, staticRenderFns } from "./CustomizationBoxMain.vue?vue&type=template&id=aaf65cf6&scoped=true&"
import script from "./CustomizationBoxMain.vue?vue&type=script&lang=js&"
export * from "./CustomizationBoxMain.vue?vue&type=script&lang=js&"
import style0 from "./CustomizationBoxMain.vue?vue&type=style&index=0&id=aaf65cf6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaf65cf6",
  null
  
)

export default component.exports